export const getTenant = () => {
    return window.location.pathname.split('/').filter(it => it !== '')[0];
}